<template>
  <div class="d-flex">
    <!-- CELEBRATION TAG -->
    <div v-if="selectedCelebration" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      <img src="../../../assets/emojis/confetti-24.png" class="hw18 mr-1" />
      Celebrating a {{ selectedCelebration.toLowerCase() }}
      <font-awesome-icon :icon="['fal', 'times']" class="ml-2 cp gray900" @click="removeCelebration" />
    </div>

    <!-- FEELING TAG -->
    <div v-if="selectedFeeling && selectedFeeling.name" class="ml-1 p-2 d-flex align-items-center bg-gray100 rounded font14 gray900">
      <img :src="require(`../../../assets/emojis/${selectedFeeling.icon}.png`)" class="hw18 mr-1" />
      is feeling {{ selectedFeeling.name }}
      <font-awesome-icon :icon="['fal', 'times']" class="gray900 ml-2 cp" @click="removeFeeling" />
    </div>

    <!-- QUESTION TAG -->
    <div v-if="isQuestion" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      <font-awesome-icon :icon="['fal', 'question-circle']" class="mr-1" :style="{ color: getPrimaryColor() }" />
      Asked a question
      <font-awesome-icon v-if="!onlyQuestion && !editing" :icon="['fal', 'times']" class="gray900 ml-2 cp" @click="removeQuestionTag" />
    </div>

    <!-- CATEGORY TAG -->
    <div v-if="selectedCategory" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      {{ selectedCategory }}
      <font-awesome-icon :icon="['fal', 'exchange']" class="ml-2 cp gray900" @click="changeScreen('categorys')" />
    </div>

    <!-- POLL TAG -->
    <div v-if="postType === 'poll'" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      <font-awesome-icon :icon="['fal', 'poll']" class="mr-1 gray900" />
      Created a poll
      <font-awesome-icon :icon="['fal', 'times']" class="gray900 ml-2 cp" @click="removeTag" />
    </div>

    <!-- JOB TAG -->
    <div v-if="postType === 'job'" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      <img :src="require(`../../../assets/emojis/briefcase-72.png`)" class="hw18 mr-1" />
      Shared a job opening
      <font-awesome-icon :icon="['fal', 'times']" class="gray900 ml-2 cp" @click="removeTag" v-if="!editing" />
    </div>

    <!-- EVENT TAG -->
    <div v-if="postType === 'event'" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      <img :src="require(`../../../assets/emojis/calendar-72.png`)" class="hw18 mr-1" />
      Created an event
      <font-awesome-icon :icon="['fal', 'times']" class="gray900 ml-2 cp" @click="removeTag" v-if="!editing" />
    </div>

    <!-- PRESS RELEASE TAG -->
    <div v-if="postType === 'press'" class="ml-1 p-2 bg-gray100 rounded font14 gray900">
      <img :src="require(`../../../assets/emojis/newspaper-72.png`)" class="hw18 mr-1" />
      Shared a press release
      <font-awesome-icon :icon="['fal', 'times']" class="gray900 ml-2 cp" @click="removeTag" v-if="!editing" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DisplayTags",
  props: {
    selectedFeeling: Object,
    postType: String,
    selectedCategory: String,
    isQuestion: Boolean,
    changeScreen: Function,
    removeQuestionTag: Function,
    removeFeeling: Function,
    removeTag: Function,
    selectedCelebration: String,
    removeCelebration: Function,
    editing: Boolean,
    onlyQuestion: Boolean,
  },
  watch: {
    selectedFeeling: {
      handler(v) {
        if (v && !v.icon) {
          this.selectedFeeling = this.typesOfFeelings.find(f => f.name === v.name)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      typesOfFeelings: [
        { name: "Happy", icon: "happy-40" },
        { name: "Blessed", icon: "Blessed-24" },
        { name: "Loved", icon: "Loved-24" },
        { name: "Angry", icon: "angry-40" },
        { name: "Crazy", icon: "Crazy-24" },
        { name: "Amazing", icon: "Amazing-24" },
        { name: "Festive", icon: "Festive-24" },
        { name: "Tired", icon: "Tired-24" },
        { name: "Confident", icon: "Confident-24" },
        { name: "Hot", icon: "hot-24" },
        { name: "Cold", icon: "Cold-24" },
        { name: "Sick", icon: "Sick-24" },
        { name: "Speachless", icon: "Speachless-24" },
        { name: "Cool", icon: "Cool-24" },
        { name: "Scared", icon: "Scared-24" },
        { name: "Emotional", icon: "emotional-40" },
        { name: "Injured", icon: "Injured-24" },
        { name: "In Love", icon: "inlove-24" },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/home/createNewPost/DisplayTags.vue